<script lang="ts">
	import { beforeUpdate, onMount } from "svelte";
	import { APP_VERSION } from './scripts/constant';
	import { setBackendUrl, launchLoader, stopLoader, redirection } from "./scripts/common";
	import Header from "./components/Header.svelte";
	import Route from "./components/Route.svelte";
	import Footer from "./components/Footer.svelte";
	import Toaster from "./components/Toaster.svelte";
	import { storeActus } from "./scripts/classes/actu";
	import { storePages } from "./scripts/classes/page";
    import { getActus } from "./scripts/api/apiActus";
	import { getPages } from "./scripts/api/apiPages";
    import Loader from "./components/Loader.svelte";
	export let name: string;
	
	beforeUpdate(() => {
		setBackendUrl();
	})

	onMount(async () => {
		console.log(APP_VERSION.name + " - version " + APP_VERSION.version);
		getActusIfEmpty();
		getPagesIfEmpty();
		storePages.subscribe(data => {
			if (data.length > 0) {
				redirection();
			}
		})
	});

     function getPagesIfEmpty() {
        if ($storePages.length <= 0) {
			launchLoader();
            const returnValue = getPages();
            returnValue.then((data) => {
                stopLoader();
            });
        }
    }

     function getActusIfEmpty() {
        if ($storeActus.length <= 0) {
			launchLoader();
            const returnValue = getActus();
            returnValue.then((data) => {
                stopLoader();
            });
        }
    }

</script>

<style lang="scss">

	.main {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin: 0;
        padding: 0;
        min-height: 100vh;
		background-color: $color-primary;
        &__route {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            background-color: $color-primary;
        }

        &__header {
            min-height: $header-height-mobile;
            background-color: $color_white;
			z-index: 1000;
        }

        &__footer {
			border-top: 1px solid $color_black;
            background-color: $color-primary;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			padding: 0 20px 0 20px;
        }
	}

	@include large {
		.main {
			&__header {
				min-height: $header-height;
			}
			&__footer {
				padding: 0 0 0 0;
			}
		}
	}

</style>

<main class="main">
	<div class="main__header">
		<Header />
	</div>
	<div class="main__route">
		<Route />
	</div>
	<div class="main__footer">
		<Footer />
	</div>
	<Toaster />
	<Loader />
</main>
